import React from "react";

export const Mascot = ({light = false}) => <img src={`https://client-upload.bytehogs.com/ac/media/ac-symbol-${light ? "light" : "dark"}.png`} alt="mascot" className={`mascot ${light ? "light" : "dark"}`}/>

